import { Button, Select } from 'antd/lib';
import { useTranslation } from 'react-i18next';
import styles from './PaginationNew.module.css';

import ChevronLeft from '../../../public/assets/icons/left.svg';
import ChevronLeftEnd from '../../../public/assets/icons/left_end.svg';
import ChevronRight from '../../../public/assets/icons/right.svg';
import ChevronRightEnd from '../../../public/assets/icons/right_end.svg';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  maxResult: number;
  itemsPerPage: number;
  onItemsPerPageChange: (itemsPerPage: number) => void;
  setPage: React.Dispatch<React.SetStateAction<number>>;
}

export function PaginationNew({
  currentPage,
  totalPages,
  maxResult,
  setPage,
  itemsPerPage,
  onItemsPerPageChange
}: PaginationProps) {
  const { t } = useTranslation();
  const startIndex = currentPage * itemsPerPage + 1;
  const endIndex = Math.min((currentPage + 1) * itemsPerPage, maxResult);

  const displayStartIndex = maxResult > 0 ? startIndex : 0;
  const displayEndIndex = maxResult > 0 ? endIndex : 0;

  const handleNext = () => {
    if (currentPage < totalPages) {
      setPage((p) => p + 1);
    }
  };
  const handlePrev = () => {
    if (currentPage) {
      setPage((p) => p - 1);
    }
  };
  const handleLast = () => {
    setPage(totalPages);
  };
  const handleFirst = () => {
    setPage(0);
  };

  return (
    <div className={styles.pagination}>
      <div className={styles.section}>
        <span className={styles.pages}>{t('pagination.campaignsPerPage')}</span>
        <Select
          defaultValue={itemsPerPage}
          style={{ width: 80 }}
          size="small"
          onChange={onItemsPerPageChange}
          options={[
            { value: 10, label: 10 },
            { value: 20, label: 20 },
            { value: 30, label: 30 },
            { value: 50, label: 50 }
          ]}
        />
      </div>
      <div className={styles.section}>
        <span className={styles.pages}>
          {displayStartIndex}-{displayEndIndex} of {maxResult}
        </span>

        <Button.Group>
          <Button
            size="small"
            className={styles.button}
            disabled={!currentPage}
            onClick={handleFirst}
          >
            <ChevronLeftEnd stroke={!currentPage ? '#ccc' : 'black'} />
          </Button>
          <Button
            size="small"
            className={styles.button}
            disabled={!currentPage}
            onClick={handlePrev}
          >
            <ChevronLeft stroke={!currentPage ? '#ccc' : 'black'} />
          </Button>
          <Button
            size="small"
            className={styles.button}
            disabled={currentPage >= totalPages}
            onClick={handleNext}
          >
            <ChevronRight stroke={currentPage >= totalPages ? '#ccc' : 'black'} />
          </Button>
          <Button
            size="small"
            className={styles.button}
            disabled={currentPage >= totalPages}
            onClick={handleLast}
          >
            <ChevronRightEnd stroke={currentPage >= totalPages ? '#ccc' : 'black'} />
          </Button>
        </Button.Group>
      </div>
    </div>
  );
}
